export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';
export const HUBSPOT_CREDITS_FLAG = 'HUBSPOT_CREDITS_FLAG';
export const INBOUND_25_FLAG = 'INBOUND_25_FLAG';
export const COMMERCE_HUB_INBOUND_25_FLAG = 'COMMERCE_HUB_INBOUND_25_FLAG';
export const REMOVE_CHECKOUT_UTIL_REQUIRED_ONBOARDING_FALLBACK_FLAG = 'REMOVE_CHECKOUT_UTIL_REQUIRED_ONBOARDING_FALLBACK_FLAG';